<header class="site-header header-one {{hrefB}} {{config.skinName}}">
            <nav class="navbar-expand-lg navbar-light header-navigation stricky stricked-menu">
                <div class="container clearfix">
                    <!-- Brand and toggle get grouped for better mobile display -->
                    <div class="logo-box clearfix">
                        <a class="navbar-brand desk" href="/">
                            <img src="{{config.logo}}" class="main-logo" width="170" alt="{{config.skinName}}" />
                        </a>
                        <a class="navbar-brand mobile" href="/">
                            <img src="{{config.isotipo}}" class="main-logo" width="50" alt="{{config.skinName}}" />
                        </a>
                        <button class="menu-toggler" data-target=".main-navigation">
                            <span class="fa fa-bars"></span>
                        </button>
                    </div><!-- /.logo-box -->
                    <!-- Collect the nav links, forms, and other content for toggling -->
                    <div class="main-navigation">
                        <ul class=" navigation-box one-page-scroll-menu ">
                            <li class="scrollToLink" *ngFor="let item of headerMenu">
                                <a (click)="scrollToLink(item.href)" class="{{item.href}}" translate>{{item.title}}</a>
                            </li>

                        </ul>
                    </div><!-- /.navbar-collapse -->
                    <div class="right-side-box">
                    	<div class="right-side-bo">
                        	<a [routerLink]="['/register']"  href="#" class="thm-btn header-one__btn" translate>Crear cuenta</a>
	                    </div><!-- /.right-side-box -->
	                    <div class="right-side-bo">
	                        <a [routerLink]="['/login']" href="#" class="thm-btn header-one__btn" translate>Iniciar Sesión</a>
	                    </div>
                    </div>

                </div>
                <!-- /.container -->
            </nav>
            <nav class="navbar-expand-lg navbar-light header-navigation stricky original">
                <div class="container clearfix">
                    <!-- Brand and toggle get grouped for better mobile display -->
                    <div class="logo-box clearfix">
                        <a class="navbar-brand desk" href="/">
                            <img src="{{config.logo}}" class="main-logo" width="170" alt="{{config.skinName}}" />
                        </a>
                        <a class="navbar-brand mobile" href="/">
                            <img src="{{config.isotipo}}" class="main-logo" width="50" alt="{{config.skinName}}" />
                        </a>
                        <button class="menu-toggler" data-target=".main-navigation">
                            <span class="fa fa-bars"></span>
                        </button>
                    </div><!-- /.logo-box -->
                    <!-- Collect the nav links, forms, and other content for toggling -->
                    <div class="main-navigation">
                        <ul class=" navigation-box one-page-scroll-menu ">
                            <li class="scrollToLink" *ngFor="let item of headerMenu">
                                <a (click)="scrollToLink(item.href)" class="{{item.href}}" translate>{{item.title}}</a>
                            </li>

                        </ul>
                    </div><!-- /.navbar-collapse -->
                    <div class="right-side-box">
                        <div class="right-side-bo">
                            <a [routerLink]="['/register']" href="#" class="thm-btn header-one__btn" translate>Crear cuenta</a>
                        </div><!-- /.right-side-box -->
                        <div class="right-side-bo">
                            <a [routerLink]="['/login']" href="#" class="thm-btn header-one__btn" translate>Iniciar Sesión</a>
                        </div>
                    </div>

                </div>
                <!-- /.container -->
            </nav>
        </header><!-- /.header-one -->
